function fillList(where, list) {
	list.forEach(item => {
		where.appendChild(item)
	})
}

export {fillList}